import request from '@/utils/request'
import { encryptByDES } from '@/utils/3DES.js'
// 谷歌登录
export function googleLogin(data) {
  return request({
    url: '/google/boxGoogle',
    headers: {
      isToken: false,
	  isMallApi: true
    },
    transformRequest:[function(data){
    	return data
    }],
    method: 'post',
    data: encryptByDES(JSON.stringify(data))
  })
}
// 母包登录
export function testLogin(data) {
  return request({
    url: '/google/userTest',
    headers: {
      isToken: false,
	  isMallApi: true
    },
    transformRequest:[function(data){
    	return data
    }],
    method: 'post',
    data: encryptByDES(JSON.stringify(data))
  })
}
// 道具商城用户登录
export function propUserLogin(token) {
  return request({
    url: '/google/skip',
    headers: {
	  isToken: false,
	  isMallApi: true,
	  Identification: token
    },
    method: 'get'
  })
}
// 盒子信息
export function gmInfo() {
  return request({
    url: '/google/boxInfo',
    headers: {
	  isToken: true,
	  isMallApi: true
    },
    method: 'get'
  })
}
// 游戏登录
export function gameLogin(gameId) {
  return request({
    url: '/google/googleGame/'+gameId,
    headers: {
	  isToken: true,
	  isMallApi: true
    },
    method: 'get'
  })
}
// 充值GM币
export function getGmPay(data) {
  return request({
    // url: '/function/order/gmPay',
    url: '/payCoupon/order/gmPay',
    method: 'post',
	headers: {
		isToken: true,
		isMallApi: true
	},
	data: data
  })
}
// 充值GM币列表
export function getGmPayGoods(data) {
  return request({
    url: '/payCoupon/order/getGoodList',
    method: 'get',
	headers: {
		isToken: true,
		isMallApi: true
	},
	params: data
  })
}
// 充值GM币是否第一次(12.25日更逻辑，此接口无用)
export function getGmPayFrist(data) {
  return request({
    // url: '/function/order/getIsBuy',
    url: '/gmCoupon/order/getIsBuy',
    method: 'get',
	headers: {
		isToken: true,
		isMallApi: true
	},
	params: data
  })
}
// 获取用户平台币
export function getUserMallInfo(data) {
  return request({
    url: '/payCoupon/order/getUserMallInfo',
    method: 'get',
	headers: {
		isToken: true,
		isMallApi: true
	},
	params: data
  })
}
// 充值余额
export function getPay(data) {
  return request({
    // url: '/function/order/pay',
    url: '/payCoupon/order/pay',
    method: 'post',
	headers: {
		isToken: false,
		isMallApi: true
	},
	data: encryptByDES(JSON.stringify(data))
  })
}
// 查询vip
export function getVipInfo(id) {
  return request({
    url: '/vip/userRela/findUserRelaDetails/' + id,
    method: 'get',
	headers: {
		isToken: false,
	},
  })
}
// 获取VIP道具列表
export function getVipPropList() {
  return request({
    url: '/platCoinGift/getVipPropList',
    method: 'post',
	headers: {
		isToken: true,
		isMallApi: true
	},
  })
}
// 领取VIP道具礼包
export function getVipProp(data) {
  return request({
    url: '/platCoinGift/getVipProp',
    method: 'post',
	headers: {
		isToken: true,
		isMallApi: true
	},
	data: data
  })
}
// 获取用户VIP等级
export function getUserLevel() {
  return request({
    url: '/platCoinGift/getUserLevel',
    method: 'get',
	headers: {
		isToken: true,
		isMallApi: true
	},
  })
}
// 签到领取金币
export function getCoins() {
  return request({
    url: '/platCoinGift/coins',
    method: 'post',
	headers: {
		isToken: true,
		isMallApi: true
	},
  })
}
// 签到领取
export function doSignin(remarks) {
  return request({
    url: '/platCoinGift/signin/' + remarks,
    method: 'post',
	headers: {
		isToken: true,
		isMallApi: true
	},
  })
}
